import React from 'react'
import { useSelector, useDispatch } from 'react-redux';
import Chat from '../components/UserComponents/Chat/Chat'

import { ReactComponent as Logo  } from '../images/logo.svg'

import { ActualStreamState } from '../types';
import AppLayout from '../layouts/AppLayout';
import ProductsSlider from '../components/UserComponents/Products/ProductsSlider';
import ProductCard from '../components/UserComponents/Products/ProductCard/ProductCard'


import img1 from '../images/banana1.jpg'
import img2 from '../images/redbanana.jpg'
import img3 from '../images/blackbanana.jpg'
import img4 from '../images/bluebanana.png'

interface Product{
    name: string;
    price: number;
    photo: string;
    description: string;
}

const ProductsArray: Product[] = [
    {
        name: 'Banana',
        description: "Yellow Banana",
        photo: img1,
        price: 2.99
    },
    {
        name: 'Banana Fire',
        description: "Red Banana",
        photo: img2,
        price: 3.99
    },
    {
        name: 'Banana Monster',
        description: "Black Banana",
        photo: img3,
        price: 4
    },
    {
        name: 'Banana Pure',
        description: "Blue Banana",
        photo: img4,
        price: 7.99
    },
]

const StreamSquare  = (props:any) =>{
    const link = `https://www.youtube.com/embed/${props.videoid}?autoplay=1`;
    return (
        <div key={props.videoid} className="stream__box">
            <iframe
                width="100%"
                height="100%"
                src={link}
                frameBorder="0"
                allow="autoplay"
                >
            </iframe>
        </div>
    )
}

const ProductsRendered = ProductsArray.map( product => <ProductCard props={product}/>)


export default function StreamPage() {

    const actualStream = useSelector( (state: ActualStreamState) => { return state.actualStream})

    return (
        <AppLayout>
        <div className="stream_detail__container">
            <Logo className="stream__logo"/>
            <div className="stream__container">
                <StreamSquare videoid="dnJ52XI0oNc"/>
            </div>
            <div className="stream_detail__info">
                <h2>{actualStream.title}</h2>
                <p>{actualStream.description}</p>
                <p className="author--name">Streamer: {actualStream.author}</p>
            </div>

            <Chat title={actualStream.title}/>
        </div>
        <p className="mt-5 pt-5">Products from the stream: </p>
        <ProductsSlider>{ProductsRendered}</ProductsSlider>
        </AppLayout>
    )
}

